<script lang="ts">
  import { session, currentStep, records, selectedChecklistId, fontSize } from '../stores';
  import { checklists } from '../data/checklists';
  import { ROLE_LABELS } from '../types';
  import { renderBold, renderBoldInline } from '../helpers';

  const userSession = $derived($session);
  const checklistId = $derived($selectedChecklistId);
  const currentChecklist = $derived(
    checklists.find(c => c.id === checklistId)
  );
  const currentRecords = $derived($records);

  function handlePrintAction() {
    window.print();
  }
</script>

<div class="w-full">
  {#if currentChecklist && userSession}
    <!-- 可列印區域 -->
    <div class="print-area bg-white p-4 border border-gray-200 rounded-lg" style={`--print-font-size: ${$fontSize}px`}>
      <h1 class="print-title font-bold text-center mb-1">
        {currentChecklist.title}
      </h1>
      <p class="text-center text-gray-600 mb-3">
        {ROLE_LABELS[userSession.role]}
        {#if userSession.name} — {userSession.name}{/if}
      </p>

<!-- Print view list version -->
      <ul class="print-list list-none p-0 m-0">
        {#each currentChecklist.items as item, idx (item.id)}
          <li class="print-item mb-2 flex items-start gap-2">
            <span class="print-status shrink-0 mt-0.5">{#if currentRecords[item.id]}☑{:else}☐{/if}</span>
            <span class="print-index font-bold shrink-0">{idx + 1}.</span>
            <div class="min-w-0 markdown-content">
              <!-- Use renderBoldInline (parseInline) to avoid <p> wrapper that breaks the trailing * onto a new line -->
              <span class="print-text">{@html renderBoldInline(item.text)}</span>{#if item.required}<span class="print-required text-red-600 ml-1">*</span>{/if}
              {#if item.hint}<div class="print-hint text-gray-500 italic ml-0">{@html renderBold(item.hint)}</div>{/if}
              {#if currentRecords[item.id] && currentRecords[item.id].timestamp}
                <span class="print-timestamp text-gray-700 ml-2">（{currentRecords[item.id].timestamp}）</span>
              {/if}
            </div>
          </li>
        {/each}
      </ul>

      <div class="mt-4 pt-3 border-t border-gray-300 text-gray-500 flex gap-x-8 whitespace-nowrap">
        <span>簽名：_________________</span>
        <span>日期時間：____________</span>
      </div>
    </div>
  {/if}
</div>

<style>
  .print-area {
    font-size: var(--print-font-size);
  }

  .print-title {
    font-size: 1.15em;
    line-height: 1.25;
  }

  .print-status {
    font-size: 1.15em;
    line-height: 1;
  }

  .print-text, .print-index, .print-required {
    font-size: 1em;
  }

  .print-hint, .print-timestamp {
    font-size: 0.75em;
  }

  @media print {
    .print-area {
      border: none !important;
      border-radius: 0 !important;
      padding: 0 !important;
      /* 覆蓋全域列印的固定 12pt，列印字級與頁面設定同步。 */
      font-size: var(--print-font-size) !important;
    }
  }


  :global(.print-area .print-item) {
    list-style-type: none;
  }
  :global(.print-area td) {
    vertical-align: top;
  }
  :global(.print-area .markdown-content ul) {
    list-style-type: disc !important;
    padding-left: 1.25rem !important;
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  :global(.print-area .markdown-content ul ul) {
    list-style-type: circle !important;
    padding-left: 1.25rem !important;
  }
  :global(.print-area .markdown-content ul ul ul) {
    list-style-type: square !important;
    padding-left: 1.25rem !important;
  }
  :global(.print-area .markdown-content li) {
    display: list-item !important;
    list-style-type: inherit !important;
  }
</style>
